import { TLocations } from 'types/locations';

const getLocationOptions = (locations: TLocations | undefined) => locations?.map((location) => ({
  value: location[0].toString(),
  label: `${location[0]} - ${location[1]}`,
}));

export default getLocationOptions;
